import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-chat-heart-line text-accent-600 text-sm"></i>
            <span className="text-accent-700 text-xs font-medium">瓜友热评</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            来自千万吃瓜爱好者的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 transition-all duration-200 hover:border-primary-200 cursor-default"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.username}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-bold text-sm text-foreground-900">{item.username}</span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-100 text-accent-600">
                      {item.badge}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{item.likes.toLocaleString()} 赞</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}